"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenURLMenuItem = exports.isStandardMenuItem = exports.isStaticTextMenuItem = exports.isStaticImageMenuItem = void 0;
function isStaticImageMenuItem(item) {
    return !!item && !!item.imageUrl;
}
exports.isStaticImageMenuItem = isStaticImageMenuItem;
function isStaticTextMenuItem(item) {
    return !!item && !!item.body;
}
exports.isStaticTextMenuItem = isStaticTextMenuItem;
function isStandardMenuItem(item) {
    return !!item && !!item.label;
}
exports.isStandardMenuItem = isStandardMenuItem;
function isOpenURLMenuItem(item) {
    return !!item && !!item.url;
}
exports.isOpenURLMenuItem = isOpenURLMenuItem;
//# sourceMappingURL=guards.js.map